<template>
  <div class="pa-character-level-banner">
    <component :is="levelComponent" :class="componentClass" />
  </div>
</template>

<script>
import Level1TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter1.svg?inlineN'
import Level2TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level3TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level4TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level5TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level6TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level7TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level8TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level9TitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level10TitleImage from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'
import Level11TitleImage from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'

import LevelUnkownTitleImage  from '@/components/Pages/Home/CharacterStatusIndex/Images/Chapters/chapter_unkown.svg?inlineN'

export default {
  props : {
    characterLevelSlug : {
      default: 'unkown'
    },
  },
  components : {
    LevelUnkownTitleImage,

    Level1TitleImage,
    Level2TitleImage,
    Level3TitleImage,
    Level4TitleImage,
    Level5TitleImage,
    Level6TitleImage,
    Level7TitleImage,
    Level8TitleImage,
    Level9TitleImage,
    Level10TitleImage,
    Level11TitleImage
  },
  data(){
    return {
      levelComponent  : 'LevelUnkownImage',
      componentClass  : [],
    };
  },
  watch : {
    characterLevelSlug : {
      handler(slug){
        let componentSlug = this._.upperFirst(slug);
        componentSlug = componentSlug.replace('Level', '');
        
        this.levelComponent = 'Level'+componentSlug+'TitleImage';
        
        let className = this._.toLower(slug);
        
        this.componentClass = ['pa-image', 'pa-image-'+className];
      },
      immediate:true,
    }
  }
}
</script>

<style lang="scss">
.pa-character-level-banner{
  svg.pa-image{
    fill:#76664a;
    
    .b{
      fill: #cab090;
    }
  }
}
</style>